import React, { useEffect, useMemo, useState } from "react";
import {
  applicantCountConstant,
  BOOKING_FORM_STATUS,
  OCCUPATION,
  RESIDENT_STATUS,
} from "../../../config/constant";
import { useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import edit from "../../../assets/icons/ic-solar_pen-bold.svg";
import { Divider, Grid, Tooltip, Typography } from "@mui/material";
import disabledEdit from "../../../assets/icons/disabled-edit.svg";
import dummyProfileImg from "../../../assets/images/dummy_profile.jpeg";
import {
  setEditPreviewApplicant,
  setIsFromPreview,
  setShowSaveAndPreview,
} from "../../new-booking-form/new-booking-form.slice";
import { useTranslation } from "react-i18next";
import ReviewInput from "../../../components/ReviewInput";
import UploadPopup from "../../../shared-components/upload-popup/UploadPopup";
import { formatDate } from "../../../utilis/common-funtions";
import digiLockerIcon from "../../../assets/icons/digilocker.svg"

const { REACT_APP_S3_BASE_URL } = process.env;

const AuthorisedSignatoryDetails = ({ applicantData, isEntityBooking, masterData }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const { oppId } = useParams();
  const isIndividualBooking = !isEntityBooking;
  const [applicantList, setApplicantList] = useState([]);
  const [fieldName, setFieldName] = useState("");
  const [images, setImages] = useState([]);
  const [openPopup, setOpenPopup] = useState(false);

  const MASTER_OCCUPATION = useMemo(() => {
    const obj = {};
    masterData?.Occupation?.forEach(o => {
      const key = o.value
        ?.toUpperCase()
        ?.replace(/[\s-]+/g, "_")
      obj[key] = o?.value;
    });
    return obj;
  }, [masterData]);

  useEffect(() => {
    let obj = [];
    const applicants = ["applicant1", "applicant2", "applicant3", "applicant4"];

    applicants.forEach((key) => {
      if (applicantData && applicantData[key] !== null) {
        obj.push(applicantData[key]);
      }
    });

    setApplicantList(obj);
  }, [applicantData]);

  const handleView = (name, docs) => {
    setFieldName(name);
    setImages(docs[name] || []);
    setOpenPopup(true);
  };

  return (
    <>
      {applicantList &&
        applicantList?.length > 0 &&
        applicantList?.map((data, index) => {
          const documents = {
            legalGuardianDoc: data?.personalDetails?.legalGuardianDoc || [],
          };
          const isPhysicalDoc = data?.personalDetails?.isPhysicalLegalGuardianDoc;
          const contactNumber = data?.personalDetails?.contactNumber
            ? `${data.personalDetails.countryCode}${data.personalDetails.contactNumber}`
            : data?.contactDetails?.contactNumber
            ? `${data.contactDetails.countryCode}${data.contactDetails.contactNumber}`
            : "N/A";
          const emailAddress =
            data?.personalDetails?.emailAddress ||
            data?.contactDetails?.emailAddress ||
            "N/A";
          const decodeHtml = (str) => {
            const txt = document.createElement("textarea");
            txt.innerHTML = str;
            return txt.value;
          };

          return (
            <div
              key={index}
              className={`applicantDetailsCard applicant${index + 1}`}
            >
              <div className="editTitleRow">
                <div className="btnApplicantTop">
                  {isEntityBooking ? (
                    <>
                      {/* update */}
                      {index + 1 > 1 && (
                        <>
                          {index + 1}
                          <sup>
                            {applicantCountConstant?.numberKeys[index + 1]}
                          </sup>
                        </>
                      )}{" "}
                      {t("preview.authorizedSignatory")}
                    </>
                  ) : (
                    <>
                      {index === 0 ? (
                        t("preview.labels.primaryApplicant")
                      ) : (
                        <>
                          {index + 1}
                          <sup>
                            {applicantCountConstant?.numberKeys[index + 1]}
                          </sup>{" "}
                          {t("preview.labels.applicant")}
                          {data?.hasContinuedAsMinor &&
                            `${t("minorDetails.labels.minor")}`}
                        </>
                      )}
                    </>
                  )}
                </div>

                {applicantData?.isCompleted !== true ? (
                  <div
                    className="editButton"
                    onClick={() => {
                      dispatch(
                        setIsFromPreview({
                          value: true,
                          index: isIndividualBooking ? index : index + 2,
                        })
                      );
                      dispatch(setShowSaveAndPreview(true));
                      dispatch(setEditPreviewApplicant(true));
                      history.push(`/booking-form/${oppId}`);
                    }}
                  >
                    <img src={edit} alt="Edit" /> {t("button.edit")}
                  </div>
                ) : (
                  <Tooltip
                    enterTouchDelay={0}
                    title={
                      applicantData?.bookingFormStatus ===
                      BOOKING_FORM_STATUS?.SIGNED_OFFLINE
                        ? t("preview.tooltip.signedOffline")
                        : applicantData?.bookingFormStatus !==
                          BOOKING_FORM_STATUS?.PARTIALLY_SIGNED
                        ? applicantData?.leegalityData?.isSignLater === true
                          ? t("preview.tooltip.signInLater")
                          : t("preview.tooltip.signNow")
                        : undefined
                    }
                    arrow
                  >
                    <div className="editButtonDisabled">
                      <img src={disabledEdit} alt="Edit" /> {t("button.edit")}
                    </div>
                  </Tooltip>
                )}
              </div>

              <div className="personalInformation">
                <div className="photo">
                  {data?.personalDetails?.image?.length > 0 ? (
                    <img
                      src={`${
                        REACT_APP_S3_BASE_URL +
                        "/" +
                        data?.personalDetails?.image?.[0]
                      }`}
                      alt="User"
                    />
                  ) : (
                    <img src={`${dummyProfileImg}`} alt="User" />
                  )}
                </div>
                <div className="informationDetails">
                  <h2 className="name">{`${data?.personalDetails?.salutation} ${
                    data?.personalDetails?.firstName
                  }${" "}${data?.personalDetails?.lastName}`}</h2>
                  {isIndividualBooking && (
                    <h3 className="relationOfApplicant">
                      {data?.hasContinuedAsMinor
                        ? ""
                        : data?.personalDetails?.relation}{" "}
                      {data?.hasContinuedAsMinor ? "" : ":"}{" "}
                      {data?.personalDetails?.relativeName}
                    </h3>
                  )}
                  <div className="personalInfo width50">
                    <div className="personalInfoRow">
                      <p className="label150">
                        {index + 1 === 1
                          ? "Primary Registration Phone number:"
                          : "Contact Number:"}
                      </p>
                      <span>{contactNumber}</span>
                    </div>

                    <div className="personalInfoRow">
                      <p className="label150">
                        {t("commonLabels.emailAddress")}:
                      </p>
                      <span
                        style={{
                          display: "flex",
                          wordBreak: "break-word", // Break long words
                          whiteSpace: "normal", // Allow wrapping
                          maxWidth: "100%", // Ensure it respects container width
                        }}
                        className="wordBreakMobile"
                      >
                        {emailAddress}
                      </span>
                    </div>

                    {isIndividualBooking && (
                      <>
                        <div className="personalInfoRow">
                          <p className="label150">
                            {t("commonLabels.dob")}:
                          </p>
                          <span>
                            {data?.personalDetails?.dob
                              ? formatDate(data?.personalDetails?.dob)
                              : "N/A"}
                          </span>
                        </div>

                        <div className="personalInfoRow">
                          <p className="label150">
                            {t("commonLabels.residentStatus")}:
                          </p>
                          <span>
                            {data?.personalDetails?.residentStatus
                              ? data?.personalDetails?.residentStatus
                              : "N/A"}
                          </span>
                        </div>

                        {!data?.hasContinuedAsMinor && (
                          <div className="personalInfoRow">
                            <p className="label150">
                              {t("additionalInfo.labels.maritalStatus")}:
                            </p>
                            <span>
                              {data?.contactDetails?.maritalStatus
                                ? data?.contactDetails?.maritalStatus
                                : "N/A"}
                            </span>
                          </div>
                        )}

                        <div className="personalInfoRow">
                          <p className="label150">
                            {t("commonLabels.gender")}:
                          </p>
                          <span>
                            {data?.personalDetails?.gender
                              ? data?.personalDetails?.gender
                              : "N/A"}
                          </span>
                        </div>

                        {data?.contactDetails?.anniversaryDate ? (
                            <div className="personalInfoRow">
                              <p className="label150">
                                {t("additionalInfo.labels.anniversaryDate")}:
                              </p>
                              <span>
                                {data?.contactDetails?.anniversaryDate
                                  ? formatDate(
                                      data?.contactDetails?.anniversaryDate
                                    )
                                  : "N/A"}
                              </span>
                            </div>
                        ) : null}

                        {/* Individuals - NRI  */}
                        {(data?.personalDetails?.residentStatus ===
                          RESIDENT_STATUS.Nri ||
                          data?.personalDetails?.residentStatus ===
                            RESIDENT_STATUS.Oci) && (
                          <div className="personalInfoRow">
                            <p className="label150">
                              {t("commonLabels.nriCountry")}:
                            </p>
                            <span>
                              {data?.personalDetails?.nriCountry || "N/A"}
                            </span>
                          </div>
                        )}

                        {/* minor */}
                        {data?.hasContinuedAsMinor ? (
                          <>
                            <div className="personalInfoRow">
                              <p className="label150">
                                {t("minorDetails.labels.fatherName")}:
                              </p>
                              <span>
                                {data?.personalDetails?.fatherName
                                  ? data?.personalDetails?.fatherName
                                  : "N/A"}
                              </span>
                            </div>
                            <div className="personalInfoRow">
                              <p className="label150">
                                {t("minorDetails.labels.motherName")}:
                              </p>
                              <span>
                                {data?.personalDetails?.motherName
                                  ? data?.personalDetails?.motherName
                                  : "N/A"}
                              </span>
                            </div>
                            <div className="personalInfoRow">
                              <p className="label150">
                                {t("minorDetails.labels.legalGuardianPreview")}:
                              </p>
                              <span>
                                {data?.personalDetails?.legalGuardian
                                  ? data?.personalDetails?.legalGuardian
                                  : "N/A"}
                              </span>
                            </div>
                          </>
                        ) : null}
                      </>
                    )}

                    {data?.personalDetails?.primaryDocument ? (
                        <div className="personalInfoRow">
                          <p className="label150">
                            {t("preview.primaryDocumentSelected")}:
                          </p>
                          <span>
                            {data?.personalDetails?.primaryDocument
                              ? data?.personalDetails?.primaryDocument
                              : "N/A"}
                          </span>
                        </div>
                    ) : null}
                  </div>
                </div>
              </div>

              <Divider sx={{ border: "1px dashed #D6D6D6", mb: 2 }} />

              <div className="personalInfo width50">
                {data?.personalDetails?.aadhaarNumber && (
                  <div className="personalInfoRow">
                    <p className="label150">
                      {t("commonLabels.aadhaarNumber")}:
                    </p>
                    <span className="width110">
                      {data?.personalDetails?.aadhaarNumber
                        ? data?.personalDetails?.aadhaarNumber
                        : "N/A"}
                    </span>
                    {data?.personalDetails?.isAadhaarVerified && (
                      <img
                        src={digiLockerIcon}
                        alt=""
                        className="digiLockerIcon"
                      />
                    )}
                  </div>
                )}
                {data?.personalDetails?.panNumber && (
                  <div className="personalInfoRow">
                    <p className="label150">
                      {t("commonLabels.panNumber")}:
                    </p>
                    <span className="width110">
                      {data?.personalDetails?.panNumber
                        ? data?.personalDetails?.panNumber
                        : "N/A"}
                    </span>
                    {data?.personalDetails?.isPanVerified && (
                      <img
                        src={digiLockerIcon}
                        alt=""
                        className="digiLockerIcon"
                      />
                    )}
                  </div>
                )}

                {(data?.personalDetails?.residentStatus ===
                  RESIDENT_STATUS.Nri ||
                  data?.personalDetails?.residentStatus ===
                    RESIDENT_STATUS.Oci) && (
                  <div className="personalInfoRow">
                    <p className="label150">
                      {t("commonLabels.passportNumber")}:
                    </p>
                    <span>
                      {data?.personalDetails?.passportNumber
                        ? data?.personalDetails?.passportNumber
                        : "N/A"}
                    </span>
                  </div>
                )}

                {data?.personalDetails?.residentStatus ===
                  RESIDENT_STATUS.Oci && (
                  <div className="personalInfoRow">
                    <p className="label150">
                      {t("commonLabels.ociNumber")}:
                    </p>
                    <span>{data?.personalDetails?.ociNumber || "N/A"}</span>
                  </div>
                )}
              </div>

              {data?.hasContinuedAsMinor && (
                <Grid item xs={12} sm={8} md={8}>
                  <ReviewInput
                    text={t("minorDetails.labels.legalGuardianDoc")}
                    name="legalGuardianDoc"
                    onView={() => handleView("legalGuardianDoc", documents)}
                    disabled={!documents?.legalGuardianDoc?.length}
                    boxWidth={{
                      xs: "100%",
                      sm: "100%",
                      md: isPhysicalDoc ? "100%" : "80%",
                    }}
                    justifyContent="flex-start"
                    isPhysicalDoc={isPhysicalDoc}
                  />
                </Grid>
              )}

              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: 600,
                  fontStyle: "italic",
                  my: 2,
                }}
              >
                {t("preview.kycNote")}
              </Typography>

              {isIndividualBooking && (
                <>
                  <Divider sx={{ border: "1px dashed #D6D6D6", my: 2 }} />
                  <h3 className="titlePersonalHD marginBottom16">
                    {t("preview.labels.communicationDetails")}:
                  </h3>
                  <div className="personalInfoRow">
                    <p className="label200">
                      {t("companyDetails.labels.permanentAddress")}:
                    </p>
                    <span className="wordBreakMobile">
                      {data?.contactDetails?.permanentAddress
                        ? `${decodeHtml(
                            data.contactDetails.permanentAddress.fullAddress ||
                              ""
                          )}`
                        : "N/A"}
                    </span>
                  </div>
                  <div className="personalInfoRow">
                    <p className="label200">
                      {t("additionalInfo.labels.communicationAddress")}:
                    </p>
                    <span className="wordBreakMobile">
                      {data?.contactDetails?.communicationAddress
                        ? `${decodeHtml(
                            data.contactDetails.communicationAddress
                              .fullAddress || ""
                          )}`
                        : "N/A"}
                    </span>
                  </div>

                  {/* Need to update for minor */}

                  {!data?.hasContinuedAsMinor && (
                    <>
                      <Divider sx={{ border: "1px dashed #D6D6D6", my: 2 }} />
                      <div className="informationDetails">
                        <h3 className="titlePersonalHD marginBottom16">
                          {t("preview.labels.professionalDetails")}:
                        </h3>
                        <div className="personalInfo width50">
                          <div className="personalInfoRow">
                            <p className="label200">
                              {t("professionalDetails.fields.occupation")}:
                            </p>
                            <span>
                              {data?.professionalDetails?.occupation || "N/A"}
                            </span>
                          </div>

                          {data?.professionalDetails?.occupation !==
                            (MASTER_OCCUPATION.RETIRED || OCCUPATION.RETIRED) &&
                            data?.professionalDetails?.occupation !==
                              (MASTER_OCCUPATION.HOMEMAKER || OCCUPATION.HOMEMAKER) &&
                            data?.professionalDetails?.occupation !==
                              (MASTER_OCCUPATION.ARMED_FORCES || OCCUPATION.ARMED_FORCES) &&
                            data?.professionalDetails?.occupation !==
                              (MASTER_OCCUPATION.EMPLOYED_GOVERNMENT_SECTOR || OCCUPATION.EMPLOYED_GOVERNMENT_SECTOR) && 
                            data?.professionalDetails?.occupation !==
                              (MASTER_OCCUPATION.I_WOULD_RATHER_NOT_SAY || OCCUPATION.I_WOULD_RATHER_NOT_SAY) && (
                              <>
                                <div className="personalInfoRow">
                                  <p className="label200">
                                    {t("professionalDetails.fields.industry")}:
                                  </p>
                                  <span>
                                    {data?.professionalDetails?.industry ||
                                      "N/A"}
                                  </span>
                                </div>
                                <div className="personalInfoRow">
                                  <p className="label200">
                                    {t(
                                      "professionalDetails.fields.companyName"
                                    )}
                                    :
                                  </p>
                                  <span>
                                    {data?.professionalDetails?.companyName ||
                                      "N/A"}
                                  </span>
                                </div>
                              </>
                            )}
                          {data?.professionalDetails?.occupation ===
                            (MASTER_OCCUPATION.EMPLOYED_GOVERNMENT_SECTOR || OCCUPATION.EMPLOYED_GOVERNMENT_SECTOR) && (
                            <div className="personalInfoRow">
                              <p className="label200">
                                {t(
                                  "professionalDetails.fields.departmentDivision"
                                )}
                                :
                              </p>
                              <span>
                                {data?.professionalDetails
                                  ?.departmentDivision || "N/A"}
                              </span>
                            </div>
                          )}
                          {(data?.professionalDetails?.occupation ===
                            (MASTER_OCCUPATION.EMPLOYED_PRIVATE_SECTOR || OCCUPATION.EMPLOYED_PRIVATE_SECTOR) ||
                            data?.professionalDetails?.occupation ===
                              (MASTER_OCCUPATION.EMPLOYED_GOVERNMENT_SECTOR || OCCUPATION.EMPLOYED_GOVERNMENT_SECTOR)) && (
                            <div className="personalInfoRow">
                              <p className="label200">
                                {t("professionalDetails.fields.designation")}:
                              </p>
                              <span>
                                {data?.professionalDetails
                                  ?.designationIfOthers || "N/A"}
                              </span>
                            </div>
                          )}

                          {data?.professionalDetails?.occupation ===
                            (MASTER_OCCUPATION.ARMED_FORCES || OCCUPATION.ARMED_FORCES) && (
                            <>
                              <div className="personalInfoRow">
                                <p className="label200">
                                  {t("preview.labels.branch")}:
                                </p>
                                <span>
                                  {data?.professionalDetails?.branch || "N/A"}
                                </span>
                              </div>

                              <div className="personalInfoRow">
                                <p className="label200">
                                  {t("preview.labels.rank")}:
                                </p>
                                <span>
                                  {data?.professionalDetails?.rank || "N/A"}
                                </span>
                              </div>
                            </>
                          )}
                          <div className="personalInfoRow">
                            <p className="label200">
                              {t("preview.labels.annualIncome")}:
                            </p>
                            <span>{`${
                              decodeHtml(
                                data?.professionalDetails?.annualIncome
                              ) || "N/A"
                            }`}</span>
                          </div>
                          <div className="personalInfoRow">
                            <p className="label200">
                              {t("preview.professionalDetails.isGSTClaimed")}:
                            </p>
                            <span>
                              {data?.professionalDetails?.isGstClaimed
                                ? "Yes"
                                : "No"}
                            </span>
                          </div>
                          {data?.professionalDetails?.isGstClaimed && (
                            <>
                              <div className="personalInfoRow">
                                <p className="label200">
                                  {t("preview.professionalDetails.gstNumber")}:
                                </p>
                                <span>
                                  {data?.professionalDetails?.gstNumber ||
                                    "N/A"}
                                </span>
                              </div>
                              <div className="personalInfoRow">
                                <p className="label200">
                                  {t(
                                    "preview.professionalDetails.gstLegalName"
                                  )}
                                  :
                                </p>
                                <span>
                                  {data?.professionalDetails?.gstLegalName ||
                                    "N/A"}
                                </span>
                              </div>
                              <div className="personalInfoRow">
                                <p className="label200">
                                  {t(
                                    "preview.professionalDetails.gstBusinessName"
                                  )}
                                  :
                                </p>
                                <span>
                                  {data?.professionalDetails?.gstBusinessName ||
                                    "N/A"}
                                </span>
                              </div>
                            </>
                          )}
                        </div>{" "}
                        {(data?.professionalDetails?.occupation ===
                         (MASTER_OCCUPATION.BUSINESS || OCCUPATION.BUSINESS) ||
                          data?.professionalDetails?.occupation ===
                            (MASTER_OCCUPATION.EMPLOYED_GOVERNMENT_SECTOR || OCCUPATION.EMPLOYED_GOVERNMENT_SECTOR) ||
                          data?.professionalDetails?.occupation ===
                            (MASTER_OCCUPATION.EMPLOYED_PRIVATE_SECTOR || OCCUPATION.EMPLOYED_PRIVATE_SECTOR)) && (
                          <>
                            {data?.professionalDetails?.companyAddress && (
                              <div className="personalInfoRow">
                                <p className="label200">
                                  {t(
                                    "professionalDetails.fields.companyAddress"
                                  )}
                                  :
                                </p>
                                <span
                                  style={{
                                    whiteSpace: "pre-wrap",
                                    wordBreak: "break-word",
                                  }}
                                >
                                  {data.professionalDetails.companyAddress.includes(
                                    data?.professionalDetails?.companyPinCode ||
                                      ""
                                  )
                                    ? data.professionalDetails.companyAddress
                                    : `${
                                        data.professionalDetails.companyAddress
                                      }${
                                        data?.professionalDetails
                                          ?.companyPinCode
                                          ? `, ${data.professionalDetails.companyPinCode}`
                                          : ""
                                      }`}
                                </span>
                              </div>
                            )}
                          </>
                        )}
                        {data?.professionalDetails?.occupation ===
                          (MASTER_OCCUPATION.ARMED_FORCES || OCCUPATION.ARMED_FORCES) && (
                          <>
                            {" "}
                            <div className="personalInfoRow">
                              <p className="label200">
                                {t("professionalDetails.fields.officeAddress")}:
                              </p>
                              <span>
                                {data?.professionalDetails?.officeAddress
                                  ? data.professionalDetails.officeAddress.includes(
                                      data.professionalDetails.officePinCode
                                    )
                                    ? data.professionalDetails.officeAddress
                                    : `${
                                        data.professionalDetails.officeAddress
                                      }, ${
                                        data.professionalDetails
                                          .officePinCode || ""
                                      }`
                                  : "N/A"}
                              </span>
                            </div>
                          </>
                        )}
                      </div>
                    </>
                  )}
                </>
              )}

              {openPopup && (
                <UploadPopup
                  heading="View"
                  totalImages={1}
                  closePopup={() => setOpenPopup(false)}
                  uploadedImage={images[0] ? [images[0]] : []}
                  fieldName={fieldName}
                  hidePhysicalCopyOption
                  dynamicSize={1}
                  hideCameraOption={false}
                  showDeleteIcon={false}
                />
              )}
            </div>
          );
        })}
    </>
  );
};

export default AuthorisedSignatoryDetails;
